import { useState, useEffect } from 'react';
import Logo from '../../../components/feature/Logo';

const NAV_LINKS = [
  { label: 'Inicio', href: '#inicio' },
  { label: 'Sobre Nosotros', href: '#sobre-nosotros' },
  { label: 'Servicios', href: '#servicios' },
  { label: 'Cómo Funciona', href: '#como-funciona' },
  { label: 'Testimonios', href: '#testimonios' },
  { label: 'FAQ', href: '#faq' },
  { label: 'Contacto', href: '#contacto' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('inicio');

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const id = href.replace('#', '');
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
      setActiveSection(id);
    }
    setMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-sm py-3' : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <a href="#inicio" onClick={(e) => handleNavClick(e, '#inicio')} className="flex items-center gap-2 cursor-pointer">
          <Logo variant={scrolled ? 'dark' : 'light'} />
        </a>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => handleNavClick(e, link.href)}
              className={`text-sm font-medium tracking-wide transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                scrolled
                  ? activeSection === link.href.replace('#', '')
                    ? 'text-[#1B3A5C]'
                    : 'text-gray-600 hover:text-[#1B3A5C]'
                  : activeSection === link.href.replace('#', '')
                  ? 'text-white'
                  : 'text-white/80 hover:text-white'
              }`}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contacto"
            onClick={(e) => handleNavClick(e, '#contacto')}
            className="ml-2 px-5 py-2.5 bg-[#3D9E8C] text-white text-sm font-semibold rounded-full hover:bg-[#2d8a78] transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            Consulta Gratuita
          </a>
        </nav>

        {/* Mobile hamburger */}
        <button
          className={`md:hidden w-8 h-8 flex flex-col justify-center items-center gap-1.5 cursor-pointer`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Abrir menú"
        >
          <span className={`block w-6 h-0.5 transition-all ${scrolled ? 'bg-[#1B3A5C]' : 'bg-white'}`} />
          <span className={`block w-6 h-0.5 transition-all ${scrolled ? 'bg-[#1B3A5C]' : 'bg-white'}`} />
          <span className={`block w-4 h-0.5 transition-all ${scrolled ? 'bg-[#1B3A5C]' : 'bg-white'}`} />
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-white shadow-lg px-6 py-4 flex flex-col gap-4">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => handleNavClick(e, link.href)}
              className="text-sm font-medium text-gray-700 hover:text-[#1B3A5C] transition-colors cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contacto"
            onClick={(e) => handleNavClick(e, '#contacto')}
            className="w-fit px-5 py-2.5 bg-[#3D9E8C] text-white text-sm font-semibold rounded-full hover:bg-[#2d8a78] transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            Consulta Gratuita
          </a>
        </div>
      )}
    </header>
  );
}
